export type Mutable<Type> = {
  -readonly [Key in keyof Type]: Type[Key];
};

export function mutable<T extends string>(list: readonly T[]) {
  // convert the readonly array to a mutable copy.
  return [...list];
}
